import React, { useState, useEffect } from "react";
import "./Terms_Of_Service.css";
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";

import { TermServices } from "../../utils/apis/termsofservice/TermsOfService";

const Terms_Of_Service = () => {
  const navigate = useNavigate();

  const HtmlToReactParser = require("html-to-react").Parser;

  const htmlToReactParser = new HtmlToReactParser();

  const [terms, setTerms] = useState([]);
  const [activeSection, setActiveSection] = useState("");

  const getTerms = async () => {
    const res = await TermServices();

    if (res?.success) {
      setTerms(res?.data || []);
    }
  };

  useEffect(() => {
    getTerms();
  }, []);

  const handleScroll = (id, index) => {
    setActiveSection(id);

    const container = document.querySelector(".terms-content");

    const section = document.getElementById(id);

    if (!container) return;

    if (index < 0) {
      container.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      return;
    }

    if (section) {
      const containerTop = container.offsetTop;

      const sectionTop = section.offsetTop;

      const offset = 40;

      container.scrollTo({
        top: sectionTop - containerTop - offset,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <section
        className="term_conditions residential_service"
        
      >
        <section className="terms-wrapper"  >
          {/* Sidebar */}
          <aside className="terms-sidebar" >
            <div className="jump-box">
              <h3>Content</h3>

              <ul>
                {terms.map((item, index) => (
                  <div
                    key={item.id}
                    className={`list_holder ${
                      activeSection === `section${index}` ? "active" : ""
                    }`}
                    onClick={() => handleScroll(`section${index}`, index)}
                  >
                    <li>
                      {index + 1}. {item.name}
                    </li>
                  </div>
                ))}
              </ul>
            </div>

            {/* Social Icons */}
            <div className="social_icons_div">
              <p>Follow us on :</p>

              <div className="footer_links">
                {[
                  {
                    icon: faFacebookF,
                    link: "https://www.facebook.com",
                  },
                  {
                    icon: faInstagram,
                    link: "https://www.instagram.com",
                  },
                  {
                    icon: faLinkedinIn,
                    link: "https://www.linkedin.com",
                  },
                  {
                    icon: faXTwitter,
                    link: "https://www.twitter.com",
                  },
                ].map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    className="footer_link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="icon_holder">
                      <FontAwesomeIcon icon={item.icon} />
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </aside>

          {/* Content */}
          <div className="terms-content" >
            <div className="terms_header">
              <h5 className="terms_title">Terms of Services</h5>
            </div>

            <p className="header_text">
              Welcome to our website. By accessing or using our website,
              services, or submitting your information, you agree to comply with
              and be bound by the following Terms Of Services.
            </p>

            {terms.map((item, index) => (
              <div
                id={`section${index}`}
                className="terms-section"
                key={item.id}
              >
                <h2>
                  {index + 1}. {item.name}
                </h2>

                <p>{htmlToReactParser.parse(item.description)}</p>
              </div>
            ))}
          </div>
        </section>
      </section>
    </>
  );
};

export default Terms_Of_Service;
